// extracted by mini-css-extract-plugin
module.exports = {"amount":"amount_amount__2g5UJ","amount__header":"amount_amount__header__1B3zZ"};